import { Collapse, Container, Stack } from '@mui/material';
import { cloneDeep, get } from 'lodash';
import React, { FC, useMemo, useState } from 'react';
import MUIAlert from '../mui-alert/MUIAlert';

// import schemas
import BroadcastSchema from 'src/lib/paths/broadcast45nachricht_FULL_Paths.json';
const P = BroadcastSchema.attributes;

const BroadcastNachricht: FC<{ data: any }> = ({ data }) => {
	const [closeBroadcastIds, setCloseBroadcastIds] = useState<number[]>(() => {
		const storedIds = localStorage.getItem('broadcast-colse-ids');
		return storedIds ? JSON.parse(storedIds) : [];
	});

	const toCloseNachrichten = useMemo(() => {
		let broadcastToCloseArray = localStorage.getItem('broadcast-colse-ids');
		return broadcastToCloseArray ? JSON.parse(broadcastToCloseArray) : [];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [closeBroadcastIds]);

	const handleClose = (id: number) => {
		let copy = cloneDeep(closeBroadcastIds);
		copy.push(id);
		localStorage.setItem('broadcast-colse-ids', JSON.stringify(copy));
		setCloseBroadcastIds(copy);
	};

	return (
		<>
			{data.length > 0 && (
				<Container sx={{ mt: '1rem' }}>
					<Stack spacing={1}>
						{data.map((ele: any, i: number) => {
							return (
								<Collapse key={i} in={!toCloseNachrichten?.includes(get(ele, 'id'))}>
									<MUIAlert
										infoType={get(ele, P.Allgemein_Nachrichtentyp.path)}
										message={get(ele, P.Allgemein_Nachricht.path)}
										showCloseButton={get(ele, P.Allgemein_Verwerfbar.path, false)}
										onClose={() => handleClose(get(ele, 'id'))}
									/>
								</Collapse>
							);
						})}
					</Stack>
				</Container>
			)}
		</>
	);
};

export default BroadcastNachricht;
